<template>
  <div>
    <headingComp :heading="'Património'" :icon="require('@/assets/ic-white-patrimonio.svg')" :backgroundImage="require('@/assets/fg-antes-10@3x.jpg')"/>
    <div class="sidebar-container">
      <div class="sidebar">
        <ol>
          <li @click="scrollTo('.historia')">História</li>
          <li @click="scrollTo('.estoria-e-segredos')">Estória & Segredos</li>
          <li @click="scrollTo('.gastronomia')">Gastronomia</li>
        </ol>
      </div>
    </div>
    <div class="large-title">
      <img src="@/assets/oh-elvas-footer.svg">
    </div>
    <section class="historia-slider unselectable">
      <div class="slider-interior historia" :style="{'transform': 'translateX(' + translateHistorySlider() + ')'}">
        <section class="historia-title-section">
          <h1>História</h1>
        </section>
        <section class="historia-second-section">
          <p>Suspendisse accumsan odio vel felis tempor, eu luctus enim viverra. Vestibulum at vulputate nisl. Duis ultricies massa sed ultrices viverra. Donec rhoncus justo quis placerat placerat. Aliquam consectetur, nisl ut vestibulum posuere, metus neque dignissim orci, sit amet ornare nisi ipsum eget purus.</p>
          <img src="">
        </section>
        <section>
          <h1>História</h1>
        </section>
      </div>
    </section>
    <section class="historia-slider-scroll">
      <div class="scroll">
        <div class="scroll-line"></div>
        <div class="scroll-button" :style="{'margin-left': historyScrollButtonPosition + '%'}" @mousedown="historyScrollMoving = true"></div>
      </div>
    </section>
    <section class="estoria-e-segredos">
      <h1 class="unselectable">Estórias & Segredos</h1>
      <section class="text-container-1">
        <h2>Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.</h2>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.</p>
      </section>
      <section class="large-image-1"></section>
      <section class="image-container-1">
        <div class="image-1"></div>
        <div class="image-2"></div>
      </section>
      <section class="text-container-2">
        <h2>Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.</h2>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.</p>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.</p>
      </section>
      <section class="container-1">
        <div class="image-1"></div>
        <div class="text-1">
          <h2>Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.</p>
        </div>
      </section>
      <section class="container-2">
        <div class="text-1">
          <h2>Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.</p>
        </div>
        <div class="image-1"></div>
      </section>
    </section>
    <section class="gastronomia-slider-container gastronomia unselectable">
      <h1>Gastronomia</h1>
      <div class="gastronomia-slider">
        <div class="gastronomia-slider-interior" :style="{'transform': 'translateX(' + gastronomiaSliderPosition() + ')'}">
          <div class="slide">
            <img src="@/assets/textura-elvas-branco@3x.png" class="slide-background">
            <h4>Pratos Típicos da Nossa Terra</h4>
          </div>
          <div class="slide">
            <img src="@/assets/19044795@2x.jpg">
            <div class="slide-text">
              <h5>Nome do prato</h5>
              <p>Suspendisse accumsan odio vel felis tempor, eu luctus enim viverra. Vestibulum at vulputate nisl. Duis ultricies massa sed ultrices viverra. Donec rhoncus justo quis placerat placerat. Aliquam consectetur, nisl ut vestibulum posuere, metus neque dignissim orci, sit amet ornare nisi ipsum eget purus.</p> 
            </div>
          </div>
          <div class="slide">
            <img src="@/assets/19044795@2x.jpg">
            <div class="slide-text">
              <h5>Nome do prato</h5>
              <p>Suspendisse accumsan odio vel felis tempor, eu luctus enim viverra. Vestibulum at vulputate nisl. Duis ultricies massa sed ultrices viverra. Donec rhoncus justo quis placerat placerat. Aliquam consectetur, nisl ut vestibulum posuere, metus neque dignissim orci, sit amet ornare nisi ipsum eget purus.</p> 
            </div>
          </div>
          <div class="slide">
            <img src="@/assets/19044795@2x.jpg">
            <div class="slide-text">
              <h5>Nome do prato</h5>
              <p>Suspendisse accumsan odio vel felis tempor, eu luctus enim viverra. Vestibulum at vulputate nisl. Duis ultricies massa sed ultrices viverra. Donec rhoncus justo quis placerat placerat. Aliquam consectetur, nisl ut vestibulum posuere, metus neque dignissim orci, sit amet ornare nisi ipsum eget purus.</p> 
            </div>
          </div>
        </div>
      </div>
      <img class="arrow arrow-left" src="@/assets/arrow-orange.svg" @click="gastronomiaSlider--" v-if="gastronomiaSlider > 0">
      <img class="arrow arrow-right" src="@/assets/arrow-orange.svg" @click="gastronomiaSlider++" v-if="gastronomiaSlider < 3">
    </section>
  </div>
</template>
<script>

export default {
  name: 'estalagem',
  props: [],
  components: {
  },
  data() {
    return {
      historyScrollButtonPosition: 0,
      historyScrollSliderPosition: 0,
      historyScrollMoving: false,
      gastronomiaSlider: 0
    }
  },
  mounted () {
    window.addEventListener('mousemove', this.historyScrollMoveEvent)
    window.addEventListener('mouseup', this.mouseUpEvent)
  },
  destroyed () {
    window.removeEventListener('mousemove', this.historyScrollMoveEvent)
    window.removeEventListener('mouseup', this.mouseUpEvent)
  },
  methods: {
    historyScrollMoveEvent (e) {
      // First calculate a % that the button needs to move in the dashed bar, this goes from 0 to some arbitrary number close to 100 to prevent the slider to go trough the line at the end
      if (this.historyScrollMoving) {
        let historyScrollContainer = this.$el.querySelector('.scroll')
        if (e.pageX < historyScrollContainer.getBoundingClientRect().left + 60) {
          this.historyScrollButtonPosition = 0
        } else if (e.pageX > historyScrollContainer.getBoundingClientRect().right - 60) {
          this.historyScrollButtonPosition = 100 - (120 / historyScrollContainer.getBoundingClientRect().width * 100)
        } else {
          this.historyScrollButtonPosition = (e.pageX - historyScrollContainer.getBoundingClientRect().left - 60) / historyScrollContainer.getBoundingClientRect().width * 100
        }
        // adjust the calculated percentage above to a value between 0 and 100
        this.historyScrollSliderPosition = this.historyScrollButtonPosition / (100 - (120 / historyScrollContainer.getBoundingClientRect().width * 100)) * 100
      }
    },
    translateHistorySlider () {
      // calculate the number of pixels to move the slider depending on the size of the content and the percentage the slider button is moved
      let sliderWidth = this.$el && this.$el.querySelector('.historia-slider').getBoundingClientRect().width
      let sliderInteriorWidth = this.$el && this.$el.querySelector('.slider-interior').getBoundingClientRect().width
      let sliderHiddenContentWidth = sliderInteriorWidth - sliderWidth
      if (sliderHiddenContentWidth) {
        return - sliderHiddenContentWidth * this.historyScrollSliderPosition / 100 + 'px'
      }
    },
    mouseUpEvent (e) {
      this.historyScrollMoving = false
    },
    historyScrollMove () {
      this.$el.querySelector('.')
    },
    scrollTo (key) {
      this.$el.querySelector(key).scrollIntoView({behavior: 'smooth'})
    },
    gastronomiaSliderPosition () {
      return - this.gastronomiaSlider * 0.75 * window.innerWidth - (56 * this.gastronomiaSlider) + 'px'
    }
  }
}
</script>
<style lang="scss" scoped>
h1 {
  font-size: 80px;
  display: table;
}
h2 {
  font-weight: bold;
  font-size: 36px;
  line-height: 40px;

  @media (max-width: 700px){
    font-size: 30px;
  }
}
p {
  margin-top: 20px;
  line-height: 24px;
}
.sidebar-container {
  position: relative;
  z-index: 2;
}
.sidebar {
  width: 25%;
  position: absolute;
  top: 144px;
  ol {
    margin-left: 20px;
    li {
      font-size: 24px;
      font-weight: bold;
      padding: 5px 0;
      color: #f6b92f;
      opacity: 0.5;
      cursor: pointer;
    }
    li.active, li:hover {
      opacity: 1;
    }
  }

    @media (max-width: 700px){
    width: calc(100% - 32px);
    margin: 0 16px;
    top: 33px;

    ol {
      flex-direction: row;
      display: flex;
      width: 100%;
      margin: 0 auto;
      align-items: center;
      justify-content: center;

      li + li {
        margin-left: 16px;
        text-align: center;
      }
    }
  }

  @media (max-width: 430px){
    ol li{
      font-size: 18px;
    }
  }
}
.large-title {
  position: relative;
  margin-top: -5.5vw;
  z-index: 10;
  img {
    width: 60%;
    margin: 0 auto;
    display: block;
  }
}
.historia-slider {
  width: 100%;
  height: 80vh;
  display: flex;
  overflow: hidden;
  position: relative;
  margin-top: 80px;
  .slider-interior {
    position: absolute;
    display: flex;
    height: 100%;
    .historia-title-section {
      display: flex;
      width: 90vw;
      height: 100%;
      h1 {
        margin: auto 35vw auto 35vw;
        font-size: 84px;
        font-weight: bold;
        text-align: center;
        color: #a79374;
        width: 30vw;
        @media (max-width: 700px){
          font-size: 60px;
        }
      }
    }
    .historia-second-section {
      display: flex;
      width: 80vw;
      height: 100%;
      background: #dfcfb6;
    }
  }
}
.historia-slider-scroll {
  position: relative;
  margin-top: 36px;
  height: 36px;
  .scroll {
    position: absolute;
    height: 24px;
    width: 70%;
    right: 15%;
    left: 15%;
    .scroll-line {
      width: 100%;
      height: 0px;
      border: 2px dashed #dfcfb6;
    }
    .scroll-button {
      border-radius: 16px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
      background-color: #f6b92f;
      width: 120px;
      height: 24px;
      position: absolute;
      top: -11px;
      cursor: pointer;
    }
  }
}
.estoria-e-segredos {
  margin-top: 92px;
  h1 {
    margin-left: auto;
    margin-right: 5%;
    font-size: 64px;
    font-weight: bold;
    letter-spacing: -2px;
    color: #f6b92f;
    text-transform: uppercase;
  }

  @media (max-width: 700px){
    h1 {
      margin: 0 auto;
      font-size: 38px;
    }
  }

}
.text-container-1 {
  margin-left: 5%;
  margin-right: 55%;
  margin-top: 100px;

  @media (max-width: 700px){
    margin: 50px 16px 0;
  }
}
.large-image-1 {
  width: 70%;
  height: 600px;
  background: rgb(240, 241, 243);
  margin-left: 25%;
  margin-right: 5%;
  margin-top: -150px;

  @media (max-width: 700px){
    margin: 16px;
    width: calc(100% - 32px);
  }
}
.image-container-1 {
  display: flex;
  position: relative;
  & > * {
    width: 25%;
    height: 300px;
    background: rgb(228, 228, 228);
  }
  .image-1 {
    margin-left: 5%;
    margin-top: -50px;
  }
  .image-2 {
    margin-left: 150px;
    margin-top: 50px;
  }

  @media (max-width: 700px){
    .image-1, .image-2 {
      margin: 0 16px;
      width: calc(50%);
      top: 0;
      position: relative;
      right: 0;
    }
  }

    @media (max-width: 500px){
      display: flex;
      flex-direction: column;
    .image-1, .image-2 {
      width: calc(100% - 32px);
    }

    .image-2 {
      margin-top: 0;
    }
  }
}
.text-container-2 {
  margin: 100px 15% 100px 25%;

  @media (max-width: 700px){
    margin: 16px;
  }
}
.container-1 {
  display: flex;
  .image-1 {
    width: 25%;
    height: 300px;
    margin-left: 10%;
    background: rgb(228, 228, 228);
  }
  .text-1 {
    margin-top: 200px;
    margin-left: -100px;
    width: 45%;
  }

  @media (max-width: 700px){
    flex-direction: column;
    .image-1 {
      width: calc(100% - 32px);
      height: 300px;
      margin: 0 16px;
    }
    .text-1 {
      margin: 16px;
      width: calc(100% - 32px);
    }
  }
}
.container-2 {
  margin-top: 100px;
  display: flex;
  .text-1 {
    margin-left: 5%;
    width: 45%;
    margin-top: 100px;
  }
  .image-1 {
    width: 25%;
    height: 300px;
    margin-left: 20%;
    background: rgb(228, 228, 228);
  }

  @media (max-width: 700px){
    flex-direction: column;
    margin-top: 0;
    .image-1 {
      width: calc(100% - 32px);
      margin: 16px;
    }
    .text-1 {
      margin: 0 16px;
      width: calc(100% - 32px);
    }
  }
}
.gastronomia-slider-container {
  width: 75vw;
  margin: 150px 10%;
  position: relative;
  h1 {
    margin-left: auto;
    margin-right: -10vw;
    font-size: 64px;
    font-weight: bold;
    letter-spacing: -2px;
    color: #f6b92f;
    text-transform: uppercase;
    z-index: 10;
    position: relative;
  }
  .gastronomia-slider {
    width: 100%;
    height: 560px;
    margin-top: -25px;
    position: relative;
    overflow: hidden;
    .gastronomia-slider-interior {
      position: absolute;
      height: 100%;
      width: fit-content;
      display: flex;
      transition: all 0.5s;
      .slide {
        width: 75vw;
        margin-right: 56px;
      }
      .slide:first-of-type {
        height: 100%;
        background: #a79374;
        position: relative;
        .slide-background {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          object-fit: cover;
        }
        h4 {
          font-size: 64px;
          line-height: 80px;
          font-weight: bold;
          text-align: center;
          color: #ffffff;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          left: 0;
          margin: auto;
          height: fit-content;
          width: 50%;
        }
      }
      .slide:not(:first-of-type) {
        height: 100%;
        background: #f6ede0;
        display: flex;
        img {
          width: 50%;
          height: 100%;
          object-fit: cover;
        }
        .slide-text {
          width: 50%;
          h5 {
            padding: 80px 40px 0 40px;
            margin-bottom: 24px;
            font-size: 42px;
            line-height: 50px;
            line-height: 1.19;
            letter-spacing: -0.95px;
            color: #000000;
          }
          p {
            padding: 0 40px 80px 40px;
          }
        }
      }
    }
  }
  .arrow {
    position: absolute;
    top: 25px;
    bottom: 0;
    margin: auto;
    cursor: pointer;
    &.arrow-left {
      left: -40px;
      transform: rotateZ(180deg);
    }
    &.arrow-right {
      right: -40px;
    }
  }

  @media (max-width: 700px){
    width: calc(100% - 32px);
    margin: 0 auto;
    margin-bottom: 100px;
    h1 {
      margin: 0 auto;
      font-size: 38px;
    }
    .gastronomia-slider {
      margin-top: 16px;
    }
  }
}
</style>